import React, { Component } from "react";
import { Table } from "reactstrap";
import shortid from "shortid";
import moment from "moment";
import { getDollarAmount } from "../../../utils/helpers";

class ClientsCollectionsReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
    this.overAllTotal = [];
  }

  componentDidMount() {
    let { data } = this.props;
    this.setState({ data: this.getReportData(data) });
  }

  getDate = (date) => {
    if (date) {
      return moment(date).format("MM/DD/YYYY");
    }
    return "n/a";
  };

  getPastDue = (date) => {
    if (date) {
      let dateofvisit = moment(date);
      let today = moment(new Date(), "DD-MM-YYYY");
      return today.diff(dateofvisit, "days");
    }
    return "0";
  };

  getReportData = (data) => {
    return {
      headings: [
        "Date",
        "Transaction Type",
        "Num",
        "Due Date",
        "Amount",
        "Open Balance",
      ],

      columns: data,
    };
  };

  renderOverAllTotal = () => {
    return (
      <tbody>
        <tr className="row-total over-all-total">
          {this.overAllTotal &&
            this.overAllTotal.map((col, i) => {
              return (
                <td key={shortid.generate()} className={"total-sub-header"}>
                  {i === 0 ? col : getDollarAmount(Number(col))}
                </td>
              );
            })}
        </tr>
      </tbody>
    );
  };

  getTotal = (title, e, total) => {
    total[0] = "Total for " + title;
    total[1] = total[1]
      ? Number(total[1]) + Number(e.total_amt)
      : Number(e.total_amt);
    total[2] = total[2]
      ? Number(total[2]) + Number(e.balance)
      : Number(e.balance);

    //calculate overall total
    this.overAllTotal[0] = "Total";
    this.overAllTotal[1] = this.overAllTotal[1]
      ? Number(this.overAllTotal[1]) + Number(e.total_amt)
      : Number(e.total_amt);
    this.overAllTotal[2] = this.overAllTotal[2]
      ? Number(this.overAllTotal[2]) + Number(e.balance)
      : Number(e.balance);

    return total;
  };

  getTableRows = (item) => {
    return [
      {
        title: this.getDate(item.txn_date),
      },
      {
        title: "Invoice",
      },
      {
        title: item.invoice_number,
      },
      {
        title: this.getDate(item.due_date),
      },
      {
        title: getDollarAmount(Number(item.total_amt)),
      },
      {
        title: getDollarAmount(Number(item.balance)),
      },
    ];
  };

  renderTableBody = (data) => {
    return (
      data &&
      data.map((item) => {
        let total = [];
        return (
          <tbody key={shortid.generate()}>
            {item.data && item.data.length ? (
              <tr>
                <td className="inner-title">
                  {item.user_name ? item.user_name : ""}
                </td>
              </tr>
            ) : (
              <tr className="empty-row" />
            )}
            {item.data && item.data.length ? (
              item.data.map((d, i) => {
                let rows = this.getTableRows(d);
                total = this.getTotal(item.user_name, d, total);
                return (
                  <tr key={shortid.generate()} className="row-total">
                    {rows &&
                      rows.map((col) => {
                        return <td key={shortid.generate()}>{col.title}</td>;
                      })}
                  </tr>
                );
              })
            ) : (
              <tr className="empty-row" />
            )}
            {total && total.length ? (
              <tr className="row-total">
                {total.map((col, i) => {
                  return (
                    <td key={shortid.generate()} className={"total-sub-header"}>
                      {i === 0
                        ? col
                        : getDollarAmount(Number(col))}
                    </td>
                  );
                })}
              </tr>
            ) : (
              <tr className="empty-row" />
            )}
          </tbody>
        );
      })
    );
  };

  render() {
    let { data } = this.state;
    return (
      <Table responsive hover className="aging-detail-report collection-report arrange-collection-report">
        <thead>
          <tr>
            {data.headings &&
              data.headings.map((header) => {
                return <th key={shortid.generate()}>{header}</th>;
              })}
          </tr>
        </thead>
        {data.columns && data.columns.length ? (
          this.renderTableBody(data.columns)
        ) : (
          <thead />
        )}
        {this.renderOverAllTotal()}
      </Table>
    );
  }
}

export default ClientsCollectionsReport;
